import { render, staticRenderFns, recyclableRender, components } from "./u-number-keyboard.vue?vue&type=template&id=5f2a514f&scoped=true&"
var renderjs
import script from "./u-number-keyboard.vue?vue&type=script&lang=js&"
export * from "./u-number-keyboard.vue?vue&type=script&lang=js&"
import style0 from "./u-number-keyboard.vue?vue&type=style&index=0&id=5f2a514f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2a514f",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-number-keyboard/u-number-keyboard.vue"
export default component.exports